import React from 'react';

import usePressTracing from '@atlaskit/react-ufo/use-press-tracing';

import { LoadableAfterPaint } from '@confluence/loadable';
import { ErrorDisplay } from '@confluence/error-boundary/entry-points/ErrorDisplay.ts';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { withTransparentErrorBoundary } from '@confluence/error-boundary/entry-points/withErrorBoundary.ts';
import { expValEquals } from '@confluence/feature-experiments';

import { useRovoAnnouncementSplashModal } from './hooks/useRovoAnnouncementSplashModal.ts';

export const RovoAnnouncementSplashModalWrapper = withTransparentErrorBoundary({
	attribution: Attribution.FLYWHEEL_FEATURE_DISCOVERY,
})(() => {
	const { isModalVisible, onModalShown, loading, error } = useRovoAnnouncementSplashModal();

	const pressTracing = usePressTracing('create-with-rovo-splash-modal');

	if (error) {
		return <ErrorDisplay error={error} />;
	}

	if (loading || !isModalVisible) {
		return null;
	}

	if (isModalVisible && expValEquals('cc-aifc-databases-experiment', 'isEnabled', true)) {
		pressTracing();

		return <Modal onModalShown={onModalShown} />;
	}
});

const Modal = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-rovo-announcement-splash-modal" */ './RovoAnnouncementSplashContainer.tsx'
			)
		).RovoAnnouncementSplashContainer,
});
